import Logo from "../../assets/Logo.png";
import "./Login.css";
import * as React from "react";
import { isEmail } from "validator";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useSelector, useDispatch } from "react-redux";
import Divider from "@mui/material/Divider";
import { forgetPassword } from "../../actions/auth";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import {
  Avatar,
  Button,
  Paper,
  Grid,
  Typography,
  Container,
} from "@mui/material";
import { useState } from "react";
import CBXInput from "../../ui/CBXInput";

const ResetPassword = () => {
  const currentUrl = new URL(window.location.href);
  const domain = currentUrl.host;
  const url = `${currentUrl.protocol}//${domain}/resetMyPassword`;

  const [error, setError] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState(false);

  const initialState = {
    email: "",
    url,
  };

  const [formData, setFormData] = useState(initialState);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector((state) => state);

  const handleOnSubmit = (e) => {
    e.preventDefault();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  function sendData() {
    if (!isEmail(formData.email)) {
      setError("Invalid email address");
      return;
    }
    setError("");
    setErrorMessage(true);
    dispatch(forgetPassword(formData));
  }

  return (
    <div className="auth-wrapper">
      <Container component="main" maxWidth="xs" className="auth-container">
        {/* Alerts */}
        {errorMessage && (
          <Stack sx={{ width: "100%", marginBottom: "1rem" }} spacing={1}>
            {message.auth.emailSentError && (
              <Alert severity="error" className="auth-alert">
                Error: {message.auth.emailSentError}
              </Alert>
            )}

            {message.auth.emailSent && (
              <Alert severity="success" className="auth-alert">
                {message.auth.emailSent}
              </Alert>
            )}
          </Stack>
        )}

        <Paper elevation={6} className="auth-card">
          {/* Logo + brand */}
          <div className="auth-logo-wrap">
            <img
              src={Logo}
              alt="Asante Akyem Community Bank Logo"
              className="auth-logo"
            />
            <div className="auth-logo-text">
              <span className="auth-bank-name">
                ASANTE AKYEM COMMUNITY BANK, PLC.
              </span>
              <span className="auth-suite-name">CBX Suite</span>
            </div>
          </div>

          {/* 🔒 Lock + Title row */}
          <div className="auth-header-row">
            <Avatar className="auth-avatar">
              <LockOutlinedIcon />
            </Avatar>

            <Typography className="auth-title">Reset Your Password</Typography>
          </div>

          {/* Subtitle */}
          <Typography className="auth-subtitle">
            Enter the email address linked to your account and we’ll send you a
            secure link to reset your password.
          </Typography>

          <Divider className="auth-divider" />

          {/* Form */}
          <form className="auth-form" onSubmit={handleOnSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <CBXInput
                  label="Email Address"
                  placeholder="Enter email address"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>

            {error && <span className="auth-error-text">{error}</span>}

            <Divider className="auth-divider" />

            {/* Action buttons */}
            <Grid
              container
              justifyContent="flex-end"
              spacing={1}
              className="auth-actions"
            >
              <Grid item>
                <Button
                  variant="text"
                  onClick={() => navigate("/login")}
                  className="auth-btn auth-btn-secondary"
                >
                  Back to Login
                </Button>
              </Grid>

              <Grid item>
                <Button
                  onClick={sendData}
                  variant="contained"
                  className="auth-btn auth-btn-primary"
                >
                  Get Reset Link
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default ResetPassword;
